import { type EditOrderData } from "@admin/domain/orders/dto/EditOrderData";

export default function formatMoney(order: EditOrderData, field: string) {
    return `${order[field] / 100} ${order.currency_symbol}`;
}
